import React, { useEffect, useState } from "react";
import "./ListCourses.css";
import { useNavigate } from "react-router-dom";
import { data } from "./data";
import axios from "axios";
import { API, formatNumber } from "../../constants";
import LeftArrow from "../../images/left-arrow.svg";
import RightArrow from "../../images/right-arrow.svg";
import { toast } from "react-toastify";
import api from "../../Components/RefreshToken/RefreshToken";
import { useTranslation } from "react-i18next";

const ListCourses = () => {
  const coursesData = data;
  const [currentPage, setCurrentPage] = useState(1);
  const [courses, setCourses] = useState([]);
  const [coursesPerPage, setCoursesPerPage] = useState(8);
  const totalPages = Math.ceil(coursesData.length / coursesPerPage);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const courseId = localStorage.getItem("courseId");
  console.log("courseId in list courses:", courseId);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(`${API}/courses/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        // 🔥 Faqat o‘sha ID dagi kursni topish
        const filtered = response.data.filter(
          (course) => String(course.id) === String(courseId)
        );
        setCourses(filtered);
        console.log("filtered course", filtered);
        // 🔥 Agar ID yo‘q bo‘lsa — barcha kurslarni ko‘rsatamiz
        // setCourses(response.data);
      } catch (error) {
        console.error("Kurslarni olishda xato:", error);
      } finally {
      }
    };

    fetchCourses();
  }, [courseId]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePlayClick = (courseId) => {
    navigate(`/courses/${courseId}`);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setCoursesPerPage(4);
      } else {
        setCoursesPerPage(8);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const goToCourse = () => {
    const token = localStorage.getItem('token');

    if (token) {
      try {
        api.post(`${API}/student/enroll?course_id=${courseId}`, {}, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }).then((res) => {
          toast.success(t("enrolledSuccess"));
          navigate(`/student/courses/${res?.data?.id}`);

        }).catch((err) => {
          if (err.response?.status === 409) {
            api.get(`${API}/student/learning/enrollments`, {
              headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
            }).then((response) => {
              const filtered = response.data.filter(
                (course) => String(course.course.id) === String(courseId)
              );
              navigate(`/student/courses/${filtered[0]?.id}`);
              console.log("filtered enroll", filtered);
            })
              .catch((error) => {
                console.error(error);
              });
          }

          if (err.response?.status === 403) {
            toast.warning(t("firstLogin"));
          }
        })
      } catch (err) {
        toast.error(t("errorOccured"))
      }
    } else {
      toast.error(t("loginFirst"))
    }
  };

  return (
    <div className="courses container">
      <div className="courses-title-block">
        <h3 className="course-title">{t("coursesTitle")}</h3>
      </div>

      <div className="courses-block">
        {courses.length > 0 ? (
          courses.map((course) => (
            <div className="courses-card" key={course.id}>
              <div className="course-img-box">
                <img
                  className="course-img"
                  src={`${API}/${course?.photo}`}
                  alt="img"
                />
                <div className="course-language">
                  {course?.language?.charAt(0).toUpperCase() +
                    course?.language?.slice(1)}
                </div>
              </div>

              <h3 className="course-name">{course.title}</h3>
              <h3 className="courses-price">
                {formatNumber(course.price)} {t("price")}
              </h3>

              <div className="swipe-teach">
                <i className="course-icon ri-presentation-line"></i>
                <span className="course-teacher">
                  {course.mentor.first_name} {course.mentor.last_name}
                </span>
              </div>

              <div className="swipe-teach">
                <i className="swipe-icon ri-checkbox-circle-line"></i>
                <span className="course-teacher">{t("teachingProcess")}</span>
              </div>

              <div className="swipe-teach">
                <i className="swipe-icon ri-checkbox-circle-line"></i>
                <span className="course-teacher">{t("duration")}</span>
              </div>

              <div className="swipe-teach">
                <i className="swipe-icon ri-checkbox-circle-line"></i>
                <span className="course-teacher">{t("onlineChat")}</span>
              </div>

              <div className="card-bottom">
                <button
                  className="course-detail"
                  onClick={goToCourse}
                >
                  {t("getStarted")} <i className="ri-checkbox-circle-line"></i>
                </button>
              </div>
            </div>
          ))
        ) : (
          <p className="no-courses-message">{t("noCourse")}</p>
        )}
      </div>
    </div>
  );
};

export default ListCourses;
